import { Box, Grid, useMediaQuery } from "@mui/material";
import { ArrayField, Datagrid, ReferenceField, TextField, useRecordContext } from "react-admin";

import { settings } from "app";
import permissions from "app/permissions";
import { studentRequests } from "api/studentApi";
import { SectionTitle } from "features/SectionTitle";
import SecuredComponent from "server/security/SecuredComponent";
import ChangeDisciplinesDialog from "./ChangeDisciplinesDialog";
import { canChangeDisciplines } from "../utils";

const DisciplinesSection = () => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("md"));
  const record = useRecordContext();

  // a BIP student has no disciplines at all
  if (!record?.userInfo || record.userInfo.isBip) return null;

  return (
    <>
      <SectionTitle
        paddingY={2}
        title="Дисциплини"
        textAlign="center"
      />
      <Grid
        container
        spacing={2}
        sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
      >
        <Grid
          item
          xs={12}
        >
          <ArrayField source="education.disciplines">
            <Datagrid
              bulkActionButtons={false}
              rowClick={false}
              size="small"
              sx={[settings.style.detailsDatagrid, { "& .RaDatagrid-headerCell": { textAlign: "left" } }]}
            >
              <ReferenceField
                source="disciplineId"
                label="Дисциплина"
                reference={studentRequests.getCurriculumDisciplinesSelect(record?.education?.curriculumId)}
                sortable={false}
                emptyText="-"
                link={false}
              >
                <TextField source="name" />
              </ReferenceField>
              <TextField
                source="semester"
                label="Семестър"
                sortable={false}
                emptyText="-"
              />
              <TextField
                source="studyGroup"
                label="Група"
                sortable={false}
                emptyText="-"
              />
            </Datagrid>
          </ArrayField>
        </Grid>
        {canChangeDisciplines(record.userInfo) ? (
          <Grid
            item
            xs={12}
          >
            <SecuredComponent permission={permissions.canManageErasmusRegularStudents}>
              <Box sx={{ mt: 1 }}>
                <ChangeDisciplinesDialog
                  id={record.id}
                  curriculumId={record?.education?.curriculumId}
                />
              </Box>
            </SecuredComponent>
          </Grid>
        ) : null}
      </Grid>
    </>
  );
};

export default DisciplinesSection;
